import { render, staticRenderFns } from "./GalleryFilters.vue?vue&type=template&id=ca610f5a&scoped=true&"
import script from "./GalleryFilters.vue?vue&type=script&lang=js&"
export * from "./GalleryFilters.vue?vue&type=script&lang=js&"
import style0 from "./GalleryFilters.vue?vue&type=style&index=0&id=ca610f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca610f5a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GallerySearch: require('/home/bitrix/frontend/components/gallery/GallerySearch.vue').default,FiltersBox: require('/home/bitrix/frontend/components/gallery/FiltersBox.vue').default,Sorting: require('/home/bitrix/frontend/components/gallery/Sorting.vue').default})
